import React from 'react';
import { useAppSelector } from 'hooks';

import { Appointment } from '~weekly-planner/lib/common';

import { faUser, faUserNurse } from '~components/icon';

import { selectUsers } from '~care-workers/selectors/users';
import { selectClients } from '~main/selectors/clients/clients';

import GroupList from './GroupList';

interface ComponentProps {
  values: Appointment;
  setFieldValue?: any;
}

interface Participant {
  id: number;
  full_name?: string;
  [key: string]: any;
}

const FormInputGroupParticipants: React.FC<ComponentProps> = ({ values, setFieldValue }) => {
  const users = useAppSelector(selectUsers);
  const clients = useAppSelector(selectClients);

  const validParticipants = (
    type: 'Clients' | 'User',
    fullList: Participant[],
    currentList: Participant[] | undefined,
  ): { label: string; value: number }[] => {
    if (!currentList || currentList.length === 0) {
      return fullList.map(({ id, full_name }) => ({ label: full_name || '', value: Number(id) }));
    }

    const idKey = type === 'User' ? 'user_id' : 'client_id';
    const currentIds = new Set(currentList.map((item) => item[idKey]));

    return fullList
      .filter(({ id }) => !currentIds.has(Number(id)))
      .map(({ id, full_name }) => ({ label: full_name || '', value: Number(id) }));
  };

  return (
    <>
      <GroupList
        id="group-users"
        type="users"
        value={values.users}
        icon={faUserNurse}
        selectOptions={validParticipants('User', users, values.users)}
        fullParticipantsList={users}
        setFieldValue={setFieldValue}
      />
      <GroupList
        id="group-clients"
        type="clients"
        value={values.clients}
        icon={faUser}
        selectOptions={validParticipants('Clients', clients, values.clients)}
        fullParticipantsList={clients}
        setFieldValue={setFieldValue}
      />
    </>
  );
};

export default FormInputGroupParticipants;
